import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import axios from 'axios'

import App from './App.vue'
import router from './router'
import { vAddressAutocomplete } from '@/directives/addressAutocomplete'

// Styles
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import './assets/main.css'

// Configure axios defaults
axios.defaults.baseURL = import.meta.env.VITE_API_URL || 'http://localhost:3000'
axios.defaults.withCredentials = true

// Create Vuetify instance
const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#3D1951',
          secondary: '#29B533',
          accent: '#5A2A75',
          error: '#FF5252',
          info: '#5A2A75',
          success: '#29B533',
          warning: '#FFC107',
        },
      },
    },
  },
})

// Create Pinia instance
const pinia = createPinia()

// Create and mount the app
const app = createApp(App)

app.use(pinia)
app.use(router)
app.use(vuetify)
app.directive('address-autocomplete', vAddressAutocomplete)

// Global error handler
app.config.errorHandler = (error, vm, info) => {
  console.error('Global error:', error)
  console.error('Component:', vm)
  console.error('Error Info:', info)
}

app.mount('#app') 
